
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13217',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13217",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.765",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9948",
  "foundations-components": "static-1-ech-accordiontransition-jank.32",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.32",
  "foundations-theming": "static-1.4766",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.89",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8323",
  "hub-http-shared-msw-handlers": "static-1.10605",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11783",
  "I18n": "static-7.1671",
  "jasmine-runner": "static-1.6744",
  "marketplace-discovery-studio-lib": "static-1.622",
  "marketplace-storefront-base": "static-1.13280",
  "quartz": "static-1.7448",
  "react-dlb": "static-1.88",
  "react-rhumb": "static-1.17011",
  "reactive-variable-buffer-atom": "static-1.3147",
  "reporting-testing-lib": "static-1.10725",
  "reselect": "static-3.12",
  "settings-ui-lib": "static-1.12817",
  "SharedI18nStrings": "static-1.183",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7617",
  "ui-addon-i18n": "static-1.11439",
  "ui-addon-react-router-dom": "static-1.9828",
  "unified-auth": "static-1.908",
  "unified-auth-core-lib": "static-1.1190",
  "usage-tracker": "static-1.7637",
  "usage-tracker-core": "static-1.7487",
  "customer-data-property-utils": "static-1.8393",
  "hub-http": "static-1.6506",
  "integrations-lib": "static-1.17016",
  "marketplace-ui-common": "static-1.20716",
  "marketplace-ui-install": "static-1.702",
  "property-management-iframe": "static-1.14117",
  "quartz-config": "static-1.1226",
  "quartz-core": "static-1.6667",
  "quartz-routing": "static-1.878",
  "quick-fetch": "static-1.4124",
  "react": "static-7.192",
  "rpc-client-utils": "static-1.4959",
  "ts-schema": "static-1.4286",
  "ui-universal-auth": "static-1.9394",
  "UIComponents": "static-3.8729",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3613",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3725",
  "quartz-webpack": "static-1.3672",
  "bend-plugin-quartz-routing": "static-1.526",
  "ai-components-ui-library": "static-1.9699",
  "codemirror": "static-5.102",
  "foundations-assets": "static-1.5177",
  "pulse": "static-1.921",
  "react-codemirror": "static-1.10932",
  "ui-extensions-preview-lib": "static-1.591",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.32",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2482",
  "framer-motion": "static-1.79",
  "hs-story-utils": "static-1.9716",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.68",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5550",
  "react-virtualized": "static-2.107",
  "StyleGuideUI": "static-3.501",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2616",
  "ui-fonts": "static-1.1045",
  "ui-images": "static-2.1245",
  "bend-plugin-foundations-theming": "static-1.3249",
  "foundations-theming-base": "static-1.3751",
  "stylex": "static-1.41",
  "HeadJS": "static-2.796",
  "hs-test-utils-bend-plugin": "static-1.3434",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4605",
  "ui-addon-video-player": "static-1.8995",
  "ai-rendering-library": "static-1.11085",
  "chirp-fetch": "static-1.2186",
  "connections-embed-lib": "static-1.1501",
  "copilot-toolkit": "static-1.11838",
  "feedback-loader": "static-1.29800",
  "laboratory-lib": "static-3.7444",
  "marketplace-embed": "static-1.22890",
  "marketplace-ui-details": "static-1.10611",
  "marketplace-ui-reviews": "static-1.20671",
  "marketplace-ui-tracking": "static-1.14886",
  "sanitize-text": "static-1.8447",
  "usage-tracker-multi": "static-1.6051",
  "usage-tracker-session-replay": "static-1.5323",
  "wootric-nps": "static-1.7194",
  "quartz-head": "static-1.1113",
  "web-vitals": "static-1.15",
  "apollo-link-hub-http": "static-2.4947",
  "immer": "static-1.101",
  "immerable": "static-1.4441",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2683",
  "reporting-data": "static-1.68792",
  "cssUtils": "static-1.912",
  "flux-actions": "static-1.367",
  "react-colorpicker": "static-2.10510",
  "react-dnd-compat": "static-1.4910",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10662",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7627",
  "icons": "static-2.682",
  "marketplace-ui-apps-core": "static-1.19248",
  "storybook-react": "static-1.40",
  "trellis-story-utils": "static-1.4800",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.32",
  "quartz-i18n": "static-1.1123",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.443",
  "ads-unified-auth-lib": "static-1.1326",
  "generic-oauth-auth-lib": "static-1.36",
  "google-sheets-integration-lib": "static-1.1013",
  "microsoft-drive-auth-lib": "static-1.126",
  "surveymonkey-integration-lib": "static-1.466",
  "slack-ui-library": "static-1.10692",
  "fsm": "static-1.4040",
  "customer-data-objects": "static-1.7983",
  "property-translator": "static-1.5689",
  "hs-locale-management": "static-1.287",
  "frontend-preferences-client": "static-1.8215",
  "hs-promise-utils": "static-1.5888",
  "hubspot-apollo-client": "static-1.5169",
  "integrations-error-boundary-lib": "static-1.14431",
  "integrations-tracking-lib": "static-1.5899",
  "native-integrations-shared-strings": "static-1.8070",
  "sanitize": "static-1.4764",
  "superstore": "static-1.5049",
  "ui-shepherd-react": "static-3.10562",
  "ai-settings-ui-library": "static-1.8340",
  "hub-http-janus": "static-1.878",
  "hubspotter-http": "static-1.4858",
  "immutable-less": "static-1.4941",
  "marketplace-ui-client-types": "static-1.18123",
  "nav-meta": "static-1.30450",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18374",
  "ui-product-approvals-common": "static-1.1026",
  "ai-studio-lib": "static-1.12436",
  "hubspot-prosemirror": "static-1.18953",
  "integrations-reconnect-lib": "static-1.474",
  "ui-addon-iframeable": "static-1.9368",
  "ui-addon-integrations-directory-panel": "static-2.8318",
  "ui-product-approvals": "static-1.29131",
  "ui-tool-access": "static-1.10447",
  "inbound-db-properties-service-client": "static-1.4049",
  "property-management-common": "static-1.6405",
  "opentelemetry-fe-types": "static-1.63",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.575",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.438",
  "quartz-auth": "static-1.1123",
  "quartz-test": "static-1.1123",
  "quartz-tracking": "static-1.827",
  "trellis-components": "static-1.2635",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.369",
  "HubStyle": "static-2.12090",
  "bender-build-tools": "static-1.3437",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22983",
  "ContentUtils": "static-1.69111",
  "customer-data-objects-ui-components": "static-1.13323",
  "sassPrefix": "static-1.184",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.424",
  "batch-promise": "static-1.1835",
  "event-emitter": "static-1.1245",
  "fast-json-patch": "static-1.70",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5746",
  "magpie-types": "static-1.5206",
  "stylex-utils": "static-1.138",
  "trellis-theming": "static-1.1266",
  "avatar-components": "static-1.2772",
  "breeze-engine-core": "static-1.989",
  "breeze-onboarding-components": "static-1.710",
  "customer-data-filters-ui": "static-1.40887",
  "customer-data-reference-ui-components": "static-1.13469",
  "embedded-academy-lib": "static-1.15490",
  "ExportDialog": "static-6.10670",
  "global-styles-ai-lib": "static-1.103",
  "highlight.js": "static-1.86",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42029",
  "reporting-snowflake": "static-1.57409",
  "reporting-ui-components": "static-2.66062",
  "reporting-visualizations": "static-1.60867",
  "trial-components-library": "static-1.14095",
  "ui-addon-teams": "static-1.21899",
  "upgrade-components-lib": "static-1.508",
  "navigation-components": "static-1.18813",
  "breeze-engine-lib": "static-1.1711",
  "simple-logging-lib": "static-1.3343",
  "fail-safe": "static-1.245",
  "app-governance-lib": "static-1.2374",
  "developer-experience-shared-components": "static-1.10803",
  "purchase-motions-components": "static-1.6354",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10225",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-public": "static-1.7448",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3992",
  "reference-resolvers": "static-1.8474",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4211",
  "hubspot-apollo-cache": "static-1.628",
  "universal-page-editor-lib": "static-1.3300",
  "final-form": "static-1.78",
  "redux-toolkit": "static-1.78",
  "simple-data-table": "static-1.3517",
  "atom": "static-1.5378",
  "merchandise-lib": "static-1.277",
  "salesImages": "static-1.554",
  "ui-addon-draggable": "static-3.5052",
  "content-assistance-lib": "static-1.8189",
  "content-media-capture": "static-1.5417",
  "customer-data-ui-utilities": "static-1.10121",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24471",
  "growth-payments-core": "static-1.26163",
  "knowledge-content-types": "static-1.8638",
  "PatternValidationJS": "static-1.3187",
  "payment-link-components": "static-1.24154",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20294",
  "ui-addon-emoji-picker": "static-1.10179",
  "ui-business-units-lib": "static-1.9381",
  "video-components-external": "static-1.12134",
  "video-data-lib": "static-1.35792",
  "navigation-messaging": "static-1.8140",
  "collaboration-sidebar": "static-1.58702",
  "crm-component-utils": "static-1.39820",
  "crm-properties-common-lib": "static-1.6182",
  "customer-data-properties": "static-1.52566",
  "external-options-client-types": "static-1.4333",
  "framework-data-schema-resolvers": "static-1.7186",
  "property-value-citations": "static-1.3180",
  "reference-resolvers-lite": "static-1.8394",
  "opentelemetry-web": "static-1.13",
  "hubspotter-http-shared-msw-handlers": "static-1.10603",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "cms-field-types": "static-1.5106",
  "content-icons-ui": "static-1.2355",
  "idb-keyval": "static-1.51",
  "reactive-lib": "static-1.1011",
  "breeze-artifacts-sdk": "static-1.302",
  "onboarding-journeys-lib": "static-1.905",
  "onboarding-scopes": "static-1.6746",
  "conversations-skeleton-state": "static-1.7537",
  "crm-message-bus": "static-1.43741",
  "customer-data-filters-ui-msw-helpers": "static-1.23322",
  "events-data-lib": "static-1.536",
  "FormUrlGenerator": "static-2.5019",
  "framework-builder-read-service-client": "static-1.4214",
  "hs-resources": "static-1.484",
  "multi-account-reference-resolvers": "static-1.1296",
  "onboarding-tours": "static-1.17107",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14447",
  "academy-common-lib": "static-1.14950",
  "dashboard-lib": "static-1.82789",
  "getting-started-shared-tasks": "static-1.19222",
  "hubspot-prosemirror-plugins": "static-1.18945",
  "share-with-third-party-component-lib": "static-1.8999",
  "ui-asset-management-lib": "static-1.11390",
  "user-context": "static-1.5412",
  "reporting-plugins": "static-1.10739",
  "reporting-reports": "static-1.68469",
  "hubs-service-types": "static-1.1552",
  "purchase-motions-api": "static-1.6357",
  "signup-constants": "static-1.19613",
  "nest": "static-1.530",
  "breeze-engine-chat-components": "static-1.689",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.196",
  "framework-listing-lib": "static-2.29475",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31411",
  "apps-service-types": "static-1.4031",
  "oauth-service-types": "static-1.4530",
  "signup-ui-url-generator": "static-2.8353",
  "onboarding-tours-client": "static-1.5322",
  "one-click-checkout": "static-1.389",
  "platform-infra-nav-components": "static-1.7885",
  "subscription-experience-data-types": "static-1.15246",
  "crm-record-cards-service-types": "static-1.3779",
  "location-customization-utils-lib": "static-1.10079",
  "redux-thunk": "static-2.80",
  "react-flip-move": "static-1.78",
  "ui-coaching-tips": "static-1.29288",
  "content-media-composition-data-lib": "static-1.13221",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4718",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.705",
  "ui-addon-opt": "static-4.8655",
  "commerce-tours-lib": "static-1.6605",
  "growth-onboarding-reliability": "static-1.5373",
  "sales-checkout-service-client": "static-1.3822",
  "data-token-picker": "static-1.16877",
  "FileManagerLib": "static-1.40111",
  "content-media-compositions": "static-2.17228",
  "media-bridge-lib": "static-1.19395",
  "chatspot-widget-iframe": "static-1.22974",
  "collaboration-sidebar-common": "static-1.3499",
  "marketing-platform-lib": "static-1.7162",
  "card-properties-lib": "static-1.44992",
  "commerce-subscription-lib": "static-1.37759",
  "crm-actions": "static-1.6646",
  "crm-cards-sdk": "static-1.44543",
  "customer-data-properties-shared-msw-handlers": "static-1.9932",
  "customer-data-tracking": "static-1.7174",
  "calling-global-api": "static-1.65587",
  "calling-internal-common": "static-1.31612",
  "calling-lifecycle-internal": "static-1.66969",
  "calling-lifecycle-messages": "static-1.59263",
  "commerce-products-lib": "static-1.10513",
  "conditional-properties-service-client": "static-1.4007",
  "crm-index-visualization-core": "static-1.4531",
  "crm-links": "static-1.6622",
  "crm-pipelines-api-client-types": "static-1.4342",
  "formula-editor": "static-1.14755",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4419",
  "meetings-icalendar-utils-lib": "static-1.928",
  "multi-currency-client-types": "static-1.3902",
  "object-builder-ui-client": "static-1.49652",
  "pipeline-validation-client-types": "static-1.4176",
  "smart-data-capture-core": "static-1.124",
  "smart-property-lib": "static-1.8274",
  "tiered-pricing": "static-1.1941",
  "topics-actions-lib": "static-1.458",
  "ui-addon-form-validation": "static-1.11274",
  "zustand": "static-1.85",
  "fdsr-migration-layer": "static-1.305",
  "framework-data-schema-quick-fetch": "static-1.7091",
  "restore-request-side-panel-lib": "static-1.1655",
  "growth-data-modal": "static-1.5885",
  "growth-onboarding-confetti": "static-1.3353",
  "growth-onboarding-next-action-utils": "static-1.2670",
  "onboarding-tours-utils": "static-1.1174",
  "ui-shepherd-tracker": "static-1.7943",
  "academy-service-client": "static-1.3980",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39970",
  "SafeStorage": "static-1.4695",
  "video-embed": "static-1.36626",
  "redux-actions": "static-3.70",
  "EmailSignatureEditor": "static-1.24988",
  "viral-links-lib": "static-1.7368",
  "nested-table": "static-1.527",
  "timezone-utils": "static-2.5536",
  "getting-started-shared-tasks-store": "static-1.18340",
  "campaign-roi-lib": "static-1.10209",
  "campaigns-utils-lib": "static-1.3502",
  "ui-addon-calendars": "static-2.5624",
  "customer-data-views-management": "static-1.26006",
  "framework-data-table": "static-2.12535",
  "nudge-client-utils": "static-1.3143",
  "nudge-custom-ui-functions": "static-1.1480",
  "switchboard-lib": "static-1.508",
  "access-check-ui-lib": "static-1.1565",
  "app-users-service-client": "static-1.5910",
  "app-users-service-types": "static-1.5318",
  "mini-checkout-client": "static-1.27484",
  "onboarding-utils": "static-1.5660",
  "permissions-shared-i18n-strings-fe": "static-1.2120",
  "ui-coaching-tips-shared-config": "static-1.29273",
  "checkout-sdk": "static-3.24327",
  "payment-method-components": "static-1.7142",
  "touchless-buying-components": "static-1.6195",
  "upgrade-catalog-service-types": "static-1.3763",
  "edison-service-client-types": "static-1.686",
  "growth-onboarding-feedback-components": "static-1.6876",
  "audio-components": "static-1.6333",
  "FileManagerImages": "static-1.37622",
  "video-components": "static-1.14136",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92806",
  "customer-data-sidebar": "static-2.46720",
  "enrichment-lib": "static-1.333",
  "ui-addon-draggable-compat": "static-2.4557",
  "universal-record-utils-lib": "static-1.1886",
  "commerce-billing-lib": "static-1.20167",
  "commerce-shared-components-lib": "static-1.19208",
  "commerce-tools-ui-lib": "static-1.11030",
  "crm-fe-perf": "static-1.23194",
  "calling-error-reporting": "static-1.31619",
  "shared-worker-versioning": "static-1.11333",
  "calling-usage-tracker": "static-1.6829",
  "voice-sms-access-library": "static-1.2026",
  "commerce-permissions": "static-1.1069",
  "products-iframe-lib": "static-1.8576",
  "products-ui-components-shared-msw-handlers": "static-1.10987",
  "crm-index-associations-lib": "static-1.6733",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10688",
  "sales-views-client-types": "static-1.4549",
  "bark-lib": "static-1.16806",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.638",
  "policy-lib": "static-1.7094",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10751",
  "onboarding-data-sync-lib": "static-1.2499",
  "growth-onboarding-next-action-components": "static-1.2698",
  "user-context-client": "static-1.4799",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4824",
  "outpost": "static-1.4448",
  "draft-convert": "static-2.80",
  "draft-extend": "static-3.83",
  "draft-js": "static-5.85",
  "draft-plugins": "static-2.22145",
  "sales-email-signature-service-client": "static-1.4137",
  "ts-utils-lib": "static-1.441",
  "crm-export-dialog": "static-1.6575",
  "crm-view-components": "static-1.1120",
  "react-beautiful-dnd": "static-1.70",
  "customer-data-associations": "static-1.7618",
  "tasks-actions-lib": "static-1.109",
  "nudge-custom-function-registry": "static-1.2900",
  "nudge-renderer-utils": "static-1.3219",
  "whisper-core-api": "static-1.7306",
  "InboxConnectUtils": "static-4.15542",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46825",
  "hub-http-rxjs": "static-1.842",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4281",
  "company-details-components": "static-1.6494",
  "react-performance-metrics-lib": "static-1.847",
  "pricing-pages-ui-components": "static-1.15780",
  "quote-checkout-service-types": "static-1.3746",
  "social-insights-client-types": "static-1.22706",
  "crm_universal": "static-1.22486",
  "customer-data-email": "static-1.18514",
  "card-payment-highlight-lib": "static-1.37959",
  "commerce-contract-lib": "static-1.13299",
  "invoices-highlight-card-lib": "static-1.55709",
  "orders-highlight-card-lib": "static-1.22178",
  "products-highlight-card-lib": "static-1.18796",
  "quotes-highlight-card-lib": "static-1.72816",
  "crm-source-interpretation-lib": "static-1.5621",
  "data-agent-utils": "static-1.395",
  "crm-object-search-query-utilities": "static-1.10178",
  "utility-belt": "static-1.2824",
  "payments-enrollment-embed-lib": "static-1.23791",
  "stripe-embedded-components": "static-1.7985",
  "customer-data-rte": "static-1.33632",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6262",
  "payments-post-enroll-local-storage-lib": "static-1.5398",
  "qrcode-generator": "static-1.76",
  "quotes-client-types": "static-1.38906",
  "calling-orchestration-schema": "static-1.36803",
  "react-reducer-toolkit": "static-1.16346",
  "meetings-connect-utils-lib": "static-1.7901",
  "hub-http-contrib": "static-1.3330",
  "ui-addon-sales-email": "static-1.5503",
  "access-control-lib": "static-1.10728",
  "EmailComponents": "static-1.55531",
  "EmailData": "static-1.54209",
  "redux-less": "static-2.9770",
  "company-details-service-types": "static-1.4231",
  "segments-query-core": "static-1.1715",
  "pricing-pages-api": "static-1.15645",
  "sequences-lib": "static-1.8520",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.41031",
  "accounting-integrations-ui-components": "static-1.7525",
  "invoices-ui-lib": "static-1.55725",
  "commerce-products-api": "static-1.2681",
  "invoices-iframe-lib": "static-1.57783",
  "quotes-modal-lib": "static-1.103494",
  "quotes-ui-lib": "static-1.81537",
  "stripe-connect-js": "static-1.75",
  "draft-content-plugins": "static-1.28891",
  "ContentComponents": "static-2.72067",
  "ContentData": "static-1.69186",
  "marketing-contacts-lib": "static-1.11003",
  "marketing-email-service-types": "static-1.2084",
  "messaging-editing-lib": "static-1.47119",
  "messaging-usage-based-billing-components-lib": "static-1.1981",
  "automation-ui-source-apps": "static-1.19669",
  "automation-ui-types": "static-1.20587",
  "messaging-types-lib": "static-1.46856",
  "onboarding-settings-client": "static-1.4800",
  "sequences-client-types-lib": "static-1.8377",
  "commerce-tax-lib": "static-1.830",
  "price-books-api": "static-1.1717",
  "price-books-components": "static-1.1775",
  "property-description-translator": "static-1.4132",
  "ramp-editor": "static-1.875",
  "commerce-analytics-service-client": "static-1.3810",
  "totals-ui-components": "static-1.24278",
  "SalesContentIndexUI": "static-3.9615",
  "advanced-menus-core": "static-1.15565",
  "advanced-menus-lib": "static-1.12440",
  "automation-ui-ubb": "static-1.6503",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7629",
  "data-token-views": "static-1.16858",
  "forms-utils-lib": "static-1.13082",
  "payments-embed-points-lib": "static-1.13576",
  "react-tinymce": "static-1.55962",
  "simple-menus-core": "static-1.15564",
  "simple-menus-lib": "static-1.17081",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55088",
  "tinymce-data": "static-1.41173",
  "tinymce-plugins": "static-1.58202",
  "tinymce-themes": "static-1.57058",
  "ui-brand-identity-lib": "static-1.16456",
  "ui-memberships-settings-lib": "static-1.34825",
  "videoconference-integration-components": "static-1.7262",
  "marketing-contacts-client": "static-1.7802",
  "mc-hard-limits-client-types": "static-1.199",
  "automation-applications-service-types": "static-1.3652",
  "automation-platform-service-types": "static-1.2663",
  "ContentEditorUI": "static-2.77890",
  "content-whatsapp-service-types": "static-1.577",
  "short-messages-app-service-client": "static-1.4207",
  "web-interactives-components": "static-1.14236",
  "web-interactives-data": "static-1.14237",
  "messaging-shared-utils-lib": "static-1.1430",
  "messaging-user-info-utils-lib": "static-1.1600",
  "email-portal-health-service-types": "static-1.1271",
  "line-items-api": "static-1.1084",
  "commerce-totals-service-types": "static-1.4025",
  "FireAlarmUi": "static-1.4714",
  "sales-templates-service-types-lib": "static-1.4378",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22523",
  "automation-ui-usage-tracking": "static-1.21986",
  "data-studio-ubb": "static-1.3491",
  "interframe": "static-3.5048",
  "layout-dnd-components": "static-1.12954",
  "layout-dnd-utils": "static-1.11929",
  "NamespacedHubStyle": "static-2.9257",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27640",
  "content-management-data-lib": "static-1.5943",
  "copilot-plugins": "static-1.11810",
  "cta-picker": "static-1.37068",
  "customer-agent-discovery-components-lib": "static-1.3931",
  "editor-components": "static-1.13638",
  "editor-iframe-lib": "static-1.8787",
  "error-messaging-js": "static-1.5489",
  "FormsCommonComponents": "static-1.86541",
  "layout-data-lib": "static-1.10254",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.73",
  "redux-request-state": "static-1.10942",
  "SharedLegalStrings": "static-1.2040",
  "smart-content-core": "static-1.43157",
  "smart-content-lib": "static-1.43810",
  "social-composer-lib": "static-1.60276",
  "structured-content-lib": "static-1.25901",
  "theme-previewer-lib": "static-1.53929",
  "tinymce-copilot": "static-1.17156",
  "xray-recommendation-lib": "static-1.8251",
  "automation-ui-routing": "static-1.21944",
  "sql-reporting-client-types": "static-1.5891",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42777",
  "reporting-enablement": "static-1.23815",
  "forms-ai-lib": "static-1.4752",
  "codemirror-dlb": "static-1.59449",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6730",
  "report-customization-components": "static-1.13897",
  "data-quality-ui-library": "static-1.13784",
  "reporting-filters": "static-1.990",
  "reporting-insights-lib": "static-1.2552",
  "merge-modal-lib": "static-1.12540",
  "segments-client-types": "static-1.11499"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13217",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.765",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9948",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.32",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.32",
  "foundations-theming": "/foundations-theming/static-1.4766",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.89",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8323",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10605",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11783",
  "I18n": "/I18n/static-7.1671",
  "jasmine-runner": "/jasmine-runner/static-1.6744",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.622",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13280",
  "quartz": "/quartz/static-1.7448",
  "react-dlb": "/react-dlb/static-1.88",
  "react-rhumb": "/react-rhumb/static-1.17011",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3147",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10725",
  "reselect": "/reselect/static-3.12",
  "settings-ui-lib": "/settings-ui-lib/static-1.12817",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7617",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11439",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9828",
  "unified-auth": "/unified-auth/static-1.908",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1190",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8393",
  "hub-http": "/hub-http/static-1.6506",
  "integrations-lib": "/integrations-lib/static-1.17016",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20716",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.702",
  "property-management-iframe": "/property-management-iframe/static-1.14117",
  "quartz-config": "/quartz-config/static-1.1226",
  "quartz-core": "/quartz-core/static-1.6667",
  "quartz-routing": "/quartz-routing/static-1.878",
  "quick-fetch": "/quick-fetch/static-1.4124",
  "react": "/react/static-7.192",
  "rpc-client-utils": "/rpc-client-utils/static-1.4959",
  "ts-schema": "/ts-schema/static-1.4286",
  "ui-universal-auth": "/ui-universal-auth/static-1.9394",
  "UIComponents": "/UIComponents/static-3.8729",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3613",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3725",
  "quartz-webpack": "/quartz-webpack/static-1.3672",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.526",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9699",
  "codemirror": "/codemirror/static-5.102",
  "foundations-assets": "/foundations-assets/static-1.5177",
  "pulse": "/pulse/static-1.921",
  "react-codemirror": "/react-codemirror/static-1.10932",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.591",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.32",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2482",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-story-utils": "/hs-story-utils/static-1.9716",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.68",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5550",
  "react-virtualized": "/react-virtualized/static-2.107",
  "StyleGuideUI": "/StyleGuideUI/static-3.501",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2616",
  "ui-fonts": "/ui-fonts/static-1.1045",
  "ui-images": "/ui-images/static-2.1245",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3249",
  "foundations-theming-base": "/foundations-theming-base/static-1.3751",
  "stylex": "/stylex/static-1.41",
  "HeadJS": "/HeadJS/static-2.796",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3434",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4605",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8995",
  "ai-rendering-library": "/ai-rendering-library/static-1.11085",
  "chirp-fetch": "/chirp-fetch/static-1.2186",
  "connections-embed-lib": "/connections-embed-lib/static-1.1501",
  "copilot-toolkit": "/copilot-toolkit/static-1.11838",
  "feedback-loader": "/feedback-loader/static-1.29800",
  "laboratory-lib": "/laboratory-lib/static-3.7444",
  "marketplace-embed": "/marketplace-embed/static-1.22890",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10611",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20671",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14886",
  "sanitize-text": "/sanitize-text/static-1.8447",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6051",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "wootric-nps": "/wootric-nps/static-1.7194",
  "quartz-head": "/quartz-head/static-1.1113",
  "web-vitals": "/web-vitals/static-1.15",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4947",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4441",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2683",
  "reporting-data": "/reporting-data/static-1.68792",
  "cssUtils": "/cssUtils/static-1.912",
  "flux-actions": "/flux-actions/static-1.367",
  "react-colorpicker": "/react-colorpicker/static-2.10510",
  "react-dnd-compat": "/react-dnd-compat/static-1.4910",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10662",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "icons": "/icons/static-2.682",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19248",
  "storybook-react": "/storybook-react/static-1.40",
  "trellis-story-utils": "/trellis-story-utils/static-1.4800",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.32",
  "quartz-i18n": "/quartz-i18n/static-1.1123",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.443",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1326",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.36",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1013",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.126",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.466",
  "slack-ui-library": "/slack-ui-library/static-1.10692",
  "fsm": "/fsm/static-1.4040",
  "customer-data-objects": "/customer-data-objects/static-1.7983",
  "property-translator": "/property-translator/static-1.5689",
  "hs-locale-management": "/hs-locale-management/static-1.287",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8215",
  "hs-promise-utils": "/hs-promise-utils/static-1.5888",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5169",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14431",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5899",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8070",
  "sanitize": "/sanitize/static-1.4764",
  "superstore": "/superstore/static-1.5049",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10562",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8340",
  "hub-http-janus": "/hub-http-janus/static-1.878",
  "hubspotter-http": "/hubspotter-http/static-1.4858",
  "immutable-less": "/immutable-less/static-1.4941",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18123",
  "nav-meta": "/nav-meta/static-1.30450",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18374",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1026",
  "ai-studio-lib": "/ai-studio-lib/static-1.12436",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18953",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.474",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9368",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8318",
  "ui-product-approvals": "/ui-product-approvals/static-1.29131",
  "ui-tool-access": "/ui-tool-access/static-1.10447",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4049",
  "property-management-common": "/property-management-common/static-1.6405",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.63",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.575",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.438",
  "quartz-auth": "/quartz-auth/static-1.1123",
  "quartz-test": "/quartz-test/static-1.1123",
  "quartz-tracking": "/quartz-tracking/static-1.827",
  "trellis-components": "/trellis-components/static-1.2635",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.369",
  "HubStyle": "/HubStyle/static-2.12090",
  "bender-build-tools": "/bender-build-tools/static-1.3437",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22983",
  "ContentUtils": "/ContentUtils/static-1.69111",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13323",
  "sassPrefix": "/sassPrefix/static-1.184",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.424",
  "batch-promise": "/batch-promise/static-1.1835",
  "event-emitter": "/event-emitter/static-1.1245",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5746",
  "magpie-types": "/magpie-types/static-1.5206",
  "stylex-utils": "/stylex-utils/static-1.138",
  "trellis-theming": "/trellis-theming/static-1.1266",
  "avatar-components": "/avatar-components/static-1.2772",
  "breeze-engine-core": "/breeze-engine-core/static-1.989",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.710",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40887",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13469",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15490",
  "ExportDialog": "/ExportDialog/static-6.10670",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.103",
  "highlight.js": "/highlight.js/static-1.86",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42029",
  "reporting-snowflake": "/reporting-snowflake/static-1.57409",
  "reporting-ui-components": "/reporting-ui-components/static-2.66062",
  "reporting-visualizations": "/reporting-visualizations/static-1.60867",
  "trial-components-library": "/trial-components-library/static-1.14095",
  "ui-addon-teams": "/ui-addon-teams/static-1.21899",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.508",
  "navigation-components": "/navigation-components/static-1.18813",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1711",
  "simple-logging-lib": "/simple-logging-lib/static-1.3343",
  "fail-safe": "/fail-safe/static-1.245",
  "app-governance-lib": "/app-governance-lib/static-1.2374",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10803",
  "purchase-motions-components": "/purchase-motions-components/static-1.6354",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10225",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-public": "/usage-tracker-public/static-1.7448",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3992",
  "reference-resolvers": "/reference-resolvers/static-1.8474",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4211",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.628",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3300",
  "final-form": "/final-form/static-1.78",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "simple-data-table": "/simple-data-table/static-1.3517",
  "atom": "/atom/static-1.5378",
  "merchandise-lib": "/merchandise-lib/static-1.277",
  "salesImages": "/salesImages/static-1.554",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5052",
  "content-assistance-lib": "/content-assistance-lib/static-1.8189",
  "content-media-capture": "/content-media-capture/static-1.5417",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10121",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24471",
  "growth-payments-core": "/growth-payments-core/static-1.26163",
  "knowledge-content-types": "/knowledge-content-types/static-1.8638",
  "PatternValidationJS": "/PatternValidationJS/static-1.3187",
  "payment-link-components": "/payment-link-components/static-1.24154",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20294",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10179",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9381",
  "video-components-external": "/video-components-external/static-1.12134",
  "video-data-lib": "/video-data-lib/static-1.35792",
  "navigation-messaging": "/navigation-messaging/static-1.8140",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58702",
  "crm-component-utils": "/crm-component-utils/static-1.39820",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6182",
  "customer-data-properties": "/customer-data-properties/static-1.52566",
  "external-options-client-types": "/external-options-client-types/static-1.4333",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7186",
  "property-value-citations": "/property-value-citations/static-1.3180",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8394",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10603",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "cms-field-types": "/cms-field-types/static-1.5106",
  "content-icons-ui": "/content-icons-ui/static-1.2355",
  "idb-keyval": "/idb-keyval/static-1.51",
  "reactive-lib": "/reactive-lib/static-1.1011",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.302",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.905",
  "onboarding-scopes": "/onboarding-scopes/static-1.6746",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7537",
  "crm-message-bus": "/crm-message-bus/static-1.43741",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23322",
  "events-data-lib": "/events-data-lib/static-1.536",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5019",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4214",
  "hs-resources": "/hs-resources/static-1.484",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1296",
  "onboarding-tours": "/onboarding-tours/static-1.17107",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14447",
  "academy-common-lib": "/academy-common-lib/static-1.14950",
  "dashboard-lib": "/dashboard-lib/static-1.82789",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19222",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18945",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8999",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11390",
  "user-context": "/user-context/static-1.5412",
  "reporting-plugins": "/reporting-plugins/static-1.10739",
  "reporting-reports": "/reporting-reports/static-1.68469",
  "hubs-service-types": "/hubs-service-types/static-1.1552",
  "purchase-motions-api": "/purchase-motions-api/static-1.6357",
  "signup-constants": "/signup-constants/static-1.19613",
  "nest": "/nest/static-1.530",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.689",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.196",
  "framework-listing-lib": "/framework-listing-lib/static-2.29475",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31411",
  "apps-service-types": "/apps-service-types/static-1.4031",
  "oauth-service-types": "/oauth-service-types/static-1.4530",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8353",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5322",
  "one-click-checkout": "/one-click-checkout/static-1.389",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7885",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15246",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3779",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10079",
  "redux-thunk": "/redux-thunk/static-2.80",
  "react-flip-move": "/react-flip-move/static-1.78",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29288",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13221",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4718",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.705",
  "ui-addon-opt": "/ui-addon-opt/static-4.8655",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6605",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5373",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3822",
  "data-token-picker": "/data-token-picker/static-1.16877",
  "FileManagerLib": "/FileManagerLib/static-1.40111",
  "content-media-compositions": "/content-media-compositions/static-2.17228",
  "media-bridge-lib": "/media-bridge-lib/static-1.19395",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22974",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3499",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7162",
  "card-properties-lib": "/card-properties-lib/static-1.44992",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37759",
  "crm-actions": "/crm-actions/static-1.6646",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44543",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9932",
  "customer-data-tracking": "/customer-data-tracking/static-1.7174",
  "calling-global-api": "/calling-global-api/static-1.65587",
  "calling-internal-common": "/calling-internal-common/static-1.31612",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66969",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59263",
  "commerce-products-lib": "/commerce-products-lib/static-1.10513",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4007",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4531",
  "crm-links": "/crm-links/static-1.6622",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4342",
  "formula-editor": "/formula-editor/static-1.14755",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4419",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.928",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3902",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49652",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4176",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.124",
  "smart-property-lib": "/smart-property-lib/static-1.8274",
  "tiered-pricing": "/tiered-pricing/static-1.1941",
  "topics-actions-lib": "/topics-actions-lib/static-1.458",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11274",
  "zustand": "/zustand/static-1.85",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.305",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7091",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1655",
  "growth-data-modal": "/growth-data-modal/static-1.5885",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3353",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2670",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1174",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7943",
  "academy-service-client": "/academy-service-client/static-1.3980",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39970",
  "SafeStorage": "/SafeStorage/static-1.4695",
  "video-embed": "/video-embed/static-1.36626",
  "redux-actions": "/redux-actions/static-3.70",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24988",
  "viral-links-lib": "/viral-links-lib/static-1.7368",
  "nested-table": "/nested-table/static-1.527",
  "timezone-utils": "/timezone-utils/static-2.5536",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18340",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10209",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3502",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5624",
  "customer-data-views-management": "/customer-data-views-management/static-1.26006",
  "framework-data-table": "/framework-data-table/static-2.12535",
  "nudge-client-utils": "/nudge-client-utils/static-1.3143",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1480",
  "switchboard-lib": "/switchboard-lib/static-1.508",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1565",
  "app-users-service-client": "/app-users-service-client/static-1.5910",
  "app-users-service-types": "/app-users-service-types/static-1.5318",
  "mini-checkout-client": "/mini-checkout-client/static-1.27484",
  "onboarding-utils": "/onboarding-utils/static-1.5660",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2120",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29273",
  "checkout-sdk": "/checkout-sdk/static-3.24327",
  "payment-method-components": "/payment-method-components/static-1.7142",
  "touchless-buying-components": "/touchless-buying-components/static-1.6195",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3763",
  "edison-service-client-types": "/edison-service-client-types/static-1.686",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6876",
  "audio-components": "/audio-components/static-1.6333",
  "FileManagerImages": "/FileManagerImages/static-1.37622",
  "video-components": "/video-components/static-1.14136",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92806",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46720",
  "enrichment-lib": "/enrichment-lib/static-1.333",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4557",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1886",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20167",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19208",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11030",
  "crm-fe-perf": "/crm-fe-perf/static-1.23194",
  "calling-error-reporting": "/calling-error-reporting/static-1.31619",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11333",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6829",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2026",
  "commerce-permissions": "/commerce-permissions/static-1.1069",
  "products-iframe-lib": "/products-iframe-lib/static-1.8576",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10987",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6733",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10688",
  "sales-views-client-types": "/sales-views-client-types/static-1.4549",
  "bark-lib": "/bark-lib/static-1.16806",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.638",
  "policy-lib": "/policy-lib/static-1.7094",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10751",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2499",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2698",
  "user-context-client": "/user-context-client/static-1.4799",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4824",
  "outpost": "/outpost/static-1.4448",
  "draft-convert": "/draft-convert/static-2.80",
  "draft-extend": "/draft-extend/static-3.83",
  "draft-js": "/draft-js/static-5.85",
  "draft-plugins": "/draft-plugins/static-2.22145",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4137",
  "ts-utils-lib": "/ts-utils-lib/static-1.441",
  "crm-export-dialog": "/crm-export-dialog/static-1.6575",
  "crm-view-components": "/crm-view-components/static-1.1120",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.70",
  "customer-data-associations": "/customer-data-associations/static-1.7618",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.109",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2900",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3219",
  "whisper-core-api": "/whisper-core-api/static-1.7306",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15542",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46825",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.842",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4281",
  "company-details-components": "/company-details-components/static-1.6494",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.847",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15780",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3746",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "crm_universal": "/crm_universal/static-1.22486",
  "customer-data-email": "/customer-data-email/static-1.18514",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37959",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13299",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55709",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22178",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18796",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72816",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5621",
  "data-agent-utils": "/data-agent-utils/static-1.395",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10178",
  "utility-belt": "/utility-belt/static-1.2824",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23791",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7985",
  "customer-data-rte": "/customer-data-rte/static-1.33632",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6262",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5398",
  "qrcode-generator": "/qrcode-generator/static-1.76",
  "quotes-client-types": "/quotes-client-types/static-1.38906",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36803",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16346",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7901",
  "hub-http-contrib": "/hub-http-contrib/static-1.3330",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5503",
  "access-control-lib": "/access-control-lib/static-1.10728",
  "EmailComponents": "/EmailComponents/static-1.55531",
  "EmailData": "/EmailData/static-1.54209",
  "redux-less": "/redux-less/static-2.9770",
  "company-details-service-types": "/company-details-service-types/static-1.4231",
  "segments-query-core": "/segments-query-core/static-1.1715",
  "pricing-pages-api": "/pricing-pages-api/static-1.15645",
  "sequences-lib": "/sequences-lib/static-1.8520",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.41031",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7525",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55725",
  "commerce-products-api": "/commerce-products-api/static-1.2681",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57783",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103494",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81537",
  "stripe-connect-js": "/stripe-connect-js/static-1.75",
  "draft-content-plugins": "/draft-content-plugins/static-1.28891",
  "ContentComponents": "/ContentComponents/static-2.72067",
  "ContentData": "/ContentData/static-1.69186",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.11003",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2084",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47119",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1981",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19669",
  "automation-ui-types": "/automation-ui-types/static-1.20587",
  "messaging-types-lib": "/messaging-types-lib/static-1.46856",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4800",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8377",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.830",
  "price-books-api": "/price-books-api/static-1.1717",
  "price-books-components": "/price-books-components/static-1.1775",
  "property-description-translator": "/property-description-translator/static-1.4132",
  "ramp-editor": "/ramp-editor/static-1.875",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3810",
  "totals-ui-components": "/totals-ui-components/static-1.24278",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9615",
  "advanced-menus-core": "/advanced-menus-core/static-1.15565",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12440",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6503",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7629",
  "data-token-views": "/data-token-views/static-1.16858",
  "forms-utils-lib": "/forms-utils-lib/static-1.13082",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13576",
  "react-tinymce": "/react-tinymce/static-1.55962",
  "simple-menus-core": "/simple-menus-core/static-1.15564",
  "simple-menus-lib": "/simple-menus-lib/static-1.17081",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55088",
  "tinymce-data": "/tinymce-data/static-1.41173",
  "tinymce-plugins": "/tinymce-plugins/static-1.58202",
  "tinymce-themes": "/tinymce-themes/static-1.57058",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16456",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34825",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7262",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7802",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.199",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3652",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2663",
  "ContentEditorUI": "/ContentEditorUI/static-2.77890",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.577",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4207",
  "web-interactives-components": "/web-interactives-components/static-1.14236",
  "web-interactives-data": "/web-interactives-data/static-1.14237",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1430",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1600",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1271",
  "line-items-api": "/line-items-api/static-1.1084",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4025",
  "FireAlarmUi": "/FireAlarmUi/static-1.4714",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4378",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22523",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21986",
  "data-studio-ubb": "/data-studio-ubb/static-1.3491",
  "interframe": "/interframe/static-3.5048",
  "layout-dnd-components": "/layout-dnd-components/static-1.12954",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11929",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9257",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27640",
  "content-management-data-lib": "/content-management-data-lib/static-1.5943",
  "copilot-plugins": "/copilot-plugins/static-1.11810",
  "cta-picker": "/cta-picker/static-1.37068",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3931",
  "editor-components": "/editor-components/static-1.13638",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8787",
  "error-messaging-js": "/error-messaging-js/static-1.5489",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86541",
  "layout-data-lib": "/layout-data-lib/static-1.10254",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.73",
  "redux-request-state": "/redux-request-state/static-1.10942",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2040",
  "smart-content-core": "/smart-content-core/static-1.43157",
  "smart-content-lib": "/smart-content-lib/static-1.43810",
  "social-composer-lib": "/social-composer-lib/static-1.60276",
  "structured-content-lib": "/structured-content-lib/static-1.25901",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53929",
  "tinymce-copilot": "/tinymce-copilot/static-1.17156",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8251",
  "automation-ui-routing": "/automation-ui-routing/static-1.21944",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5891",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42777",
  "reporting-enablement": "/reporting-enablement/static-1.23815",
  "forms-ai-lib": "/forms-ai-lib/static-1.4752",
  "codemirror-dlb": "/codemirror-dlb/static-1.59449",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6730",
  "report-customization-components": "/report-customization-components/static-1.13897",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13784",
  "reporting-filters": "/reporting-filters/static-1.990",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2552",
  "merge-modal-lib": "/merge-modal-lib/static-1.12540",
  "segments-client-types": "/segments-client-types/static-1.11499"
}
};
